// initialize chart.js
// styles
import 'virtual:uno.css'
import './assets/tailwind.css'
import './components/Charts'
import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import type { Router } from 'vue-router'
// helper functions
import Api from '@/functions/api.js'
import { setTitle } from '@/functions/app.js'
import App from './App.vue'
// global stuffs
import globalComponents from './components'
import globalDirectives from './directives'
import formatter from './functions/formatters'
import router from './routes'
// 3rd party services
import sentry from './sentry'

const pinia = createPinia()
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(sentry, router, pinia)
  .use(globalComponents)
  .use(globalDirectives)

app.config.globalProperties.fmt = formatter
app.config.globalProperties.api = Api
app.config.globalProperties.setTitle = setTitle
app.config.performance = true

app.mount('#app')

declare module 'pinia' {
  export interface PiniaCustomProperties {
    router: Router,
  }
}
